import Cookies from "js-cookie";

const getDeviceId = async () => {
  let deviceId = Cookies.get('device_id')
  if (!deviceId) {
    deviceId = localStorage.getItem('device_id')
    if (!deviceId) {
      deviceId = crypto.randomUUID()
      localStorage.setItem('device_id', deviceId)
    }
  }
  return deviceId
}

const getCsLockerToken = () => {
  return Cookies.get("cs_locker_token")
}

const removeCsLockerToken = () => {
  return Cookies.remove("cs_locker_token")
}

const getTrialPlanStorage = () => {
  return Cookies.get("trial_plan");
}

const removeTrialPlan = () => {
  Cookies.remove("trial_plan", { domain: 'locker.io' });
  Cookies.remove("trial_plan");
}

const getQueryLang = () => {
  return sessionStorage.getItem("query_lang");
}

const setQueryLang = (value) => {
  return sessionStorage.setItem("query_lang", value);
}

const removeQueryLang = () => {
  return sessionStorage.removeItem("query_lang");
}

const setIsUnlocked = () => {
  return sessionStorage.setItem("is_unlocked", 1);
}

const getIsUnlocked = () => {
  return sessionStorage.getItem("is_unlocked");
}

const removeIsUnlocked = () => {
  return sessionStorage.removeItem("is_unlocked");
}

const setSaleBlackFridayDay = (value) => {
  return localStorage.setItem("sale_black_friday_day", value);
}

const getSaleBlackFridayDay = () => {
  return localStorage.getItem("sale_black_friday_day");
}

const getPmClick = () => {
  try {
    return JSON.parse(Cookies.get('pm_click'))
  } catch (_) {
    return {
      campaign: '',
      click: ''
    }
  }
}

const getPmClickCS = () => {
  try {
    return JSON.parse(Cookies.get('pm_click_cs'))
  } catch (_) {
    return {
      campaign: '',
      click: ''
    }
  }
}

export default {
  getDeviceId,
  getCsLockerToken,
  getTrialPlanStorage,
  removeTrialPlan,
  removeCsLockerToken,
  getQueryLang,
  setQueryLang,
  removeQueryLang,
  setIsUnlocked,
  getIsUnlocked,
  removeIsUnlocked,
  setSaleBlackFridayDay,
  getSaleBlackFridayDay,
  getPmClick,
  getPmClickCS
}